import DeviceConfigContainer from '~modules/devices/containers/DeviceConfigContainer';
import dashboardWrapper from '~wrappers/dashboard';

export default dashboardWrapper(DeviceConfigContainer);
